import React from 'react';
import './BottomNav.css';

function BottomNav({ currentPage, onPageChange }) {
  const navItems = [
    { name: '首页', icon: 'home' },
    { name: '学曲', icon: 'music' },
    { name: '创作', icon: 'plus-circle', emphasized: true },
    { name: '消息', icon: 'comments' },
    { name: '我的', icon: 'user' }
  ];

  return (
    <div className="bottom-nav">
      {navItems.map((item, index) => (
        <div
          key={index}
          className={`nav-item ${currentPage === index ? 'active' : ''} ${item.emphasized ? 'emphasized' : ''}`}
          onClick={() => onPageChange(index)}
        >
          <div className="nav-icon">
            {item.emphasized ? (
              <svg viewBox="0 0 48 48" width="28" height="28">
                <circle cx="24" cy="24" r="20" fill="currentColor" />
                <line x1="24" y1="14" x2="24" y2="34" stroke="white" strokeWidth="3" strokeLinecap="round" />
                <line x1="14" y1="24" x2="34" y2="24" stroke="white" strokeWidth="3" strokeLinecap="round" />
              </svg>
            ) : (
              <i className={`fas fa-${item.icon}`}></i>
            )}
          </div>
          <div className="nav-label">{item.name}</div>
        </div>
      ))}
    </div>
  );
}

export default BottomNav;
